import { render } from "./AdminCreateTicket.vue?vue&type=template&id=1d2aae88&scoped=true"
import script from "./AdminCreateTicket.vue?vue&type=script&lang=js"
export * from "./AdminCreateTicket.vue?vue&type=script&lang=js"

import "./AdminCreateTicket.vue?vue&type=style&index=0&id=1d2aae88&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\mahatakrar\\taxbpo_admin_ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d2aae88"]])

export default __exports__